export const company = {
  ECOSIS: 'developer',
  ADMIN: 'admin',
  CLIENTE: 'customer',
  TRANSPORTADORA: 'carrier',
  REPRESENTANTE: 'representative',
}

export const companyString = {
  ECOSIS: 'Desenvolvedor',
  ADMIN: 'Administrador',
  CLIENTE: 'Cliente',
  TRANSPORTADORA: 'Transportadora',
  REPRESENTANTE: 'Representante',
}

export const inviteStatus = {
  ALL: 'all',
  INVITED: 'invited',
  NOT_INVITED: 'not_invited',
  PENDING: 'pending',
  ACCEPTED: 'accepted',
}

export const userStatus = {
  ALL: 'all',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
}

export const order = {
  BUDGET: 'B',
}

// ----------------------------------------------------

export const getCompanyTypes = () => {
  return Object.entries(company).reduce((acc, [key, value]) => {
    acc[value] = { title: companyString[key], id: value, _ref: key }

    return acc
  }, {})
}

export const companyTypes = getCompanyTypes()
